import script from "./employees-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./employees-grid.vue?vue&type=script&setup=true&lang=js"

import "./employees-grid.vue?vue&type=style&index=0&id=8e0a88d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e0a88d6"]])

export default __exports__